module.exports = __webpack_public_path__ + "media/images/countryrect/kh-765c63fd692d26b08f43ce8ed7be364c.svg";